import React from "react";

const StripeConfig = (props) => (
    <svg
        width={200}
        height={114}
        viewBox="0 0 200 114"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        {/* Background */}
        <rect width={200} height={114} rx={30} fill="#F0F3F6" />

        {/* Card */}
        <rect x={20} y={25} width={160} height={65} rx={8} fill="#A2BACA" />

        {/* Top bar icons */}
        <rect x={26} y={30} width={25} height={6} rx={3} fill="#F0F3F6" opacity={0.6} />
        <rect x={56} y={30} width={12} height={6} rx={3} fill="#F0F3F6" opacity={0.6} />

        {/* Stripe logo box */}
        <rect x={32} y={45} width={25} height={25} rx={6} fill="#6772e5" />

        {/* Clean "S" Only - Centered in 25x25 box */}
        <g transform="translate(40.5, 53) scale(0.25)">
            <path
                d="M13.88 9.515c0-1.37 1.14-1.9 2.982-1.9A19.661 19.661 0 0 1 25.6 9.876v-8.27A23.184 23.184 0 0 0 16.862.001C9.762.001 5 3.72 5 9.93c0 9.716 13.342 8.138 13.342 12.326 0 1.638-1.4 2.146-3.37 2.146-2.905 0-6.657-1.202-9.6-2.802v8.378A24.353 24.353 0 0 0 14.973 32C22.27 32 27.3 28.395 27.3 22.077c0-10.486-13.42-8.613-13.42-12.56z"
                fill="white"
                fillRule="evenodd"
            />
        </g>

        {/* Input fields */}
        <rect x={65} y={45} width={100} height={10} rx={4} fill="#F0F3F6" />
        <rect x={65} y={60} width={70} height={10} rx={4} fill="#F0F3F6" opacity={0.7} />
        <rect x={65} y={75} width={85} height={10} rx={4} fill="#F0F3F6" opacity={0.5} />
    </svg>
);

export default StripeConfig;
